<template>
    <router-link :to="{name:'newsDetail',params:{id:NoticeItem.id}}" class="newItemWrap">
        <div class="coverModule" v-if="NoticeItem.cover"><img :src="NoticeItem.cover" width="100%" /></div>
        <div class="detailModule">
            <div class="title">{{NoticeItem.title}}</div>
            <p class="desc">{{NoticeItem.description}}</p>
            <div class="dateTime">
                <span class="time">{{NoticeItem.created_at|timeFormat}}</span>
                <img :src="`${imgPath}/static/assets/img/right-arrow.png`" alt="">
            </div>
        </div>
    </router-link>
</template>
<script>
export default {
    name:'newsItem',
    props: ['NoticeItem']
}
</script>
<style lang="scss" scoped>
    .newItemWrap{
        display: flex;
        width: 100%;
        background: #FFFFFF;
        margin-top: 0.9rem;
        .coverModule{
            width: 2.4rem;
        }
        .detailModule {
            // margin-top: 0.62rem;
            flex: 1;
            margin-left: 0.2rem;
            .title{
                font-size: 0.26rem;
                font-weight: bold;
                color: #000000;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                line-clamp: 1;
                -webkit-box-orient: vertical;
            }
            .desc{
                font-size: 0.24rem;
                font-weight: 400;
                color: #7A7A7A;
                margin-top: 0.2rem;
                line-height: 0.4rem;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
            }
            .dateTime {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top: 0.2rem;
                border-top: 2px solid #CDCDCD;
                padding: 0.1rem 0;
                >span {
                    font-size: 0.22rem;
                    font-weight: 400;
                    color: #7A7A7A;
                }
                >img {
                    width: 0.28rem;
                    height: 0.12rem;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/newsItem.vue